import { Dialog } from 'ui';

import { Camera, type CameraProps } from '../Camera/Camera';

export const CameraDialog = ({
  isCameraOpen,
  toggle,
  cameraProps,
}: {
  isCameraOpen: boolean;
  toggle: () => void;
  cameraProps: CameraProps;
}) => {
  return (
    <Dialog fullScreen open={isCameraOpen}>
      <Camera
        handleCapture={cameraProps.handleCapture}
        handleClose={cameraProps.handleClose ?? toggle}
        previewImages={cameraProps.previewImages}
        handleDeletePreviewImage={cameraProps.handleDeletePreviewImage}
        handleOnComplete={cameraProps.handleOnComplete}
        showDeleteInPreview={cameraProps.showDeleteInPreview}
        guideIllustrations={cameraProps.guideIllustrations}
        materialForm={cameraProps.materialForm}
        showAerosolAnnotation={cameraProps.showAerosolAnnotation}
        showAerosolBreakdown={cameraProps.showAerosolBreakdown}
      />
    </Dialog>
  );
};
